var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-search"},[_c('vue-bootstrap-typeahead',{attrs:{"data":_vm.results,"serializer":item => item.rm_format,"placeholder":"Jump to postcode..."},on:{"hit":function($event){_vm.selectedResult = $event}},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }